/* eslint-disable react/prop-types */
import React, {useRef} from 'react';
import {
  AccessibilityInfo,
  ScrollView,
  useWindowDimensions,
  View,
} from 'react-native';
import {createMaterialTopTabNavigator} from '@react-navigation/material-top-tabs';
import {createStackNavigator} from '@react-navigation/stack';
import {noop} from 'lodash';
import PropTypes from 'prop-types';

import LoadingIndicator from '/component/base/LoadingIndicator';
import KeyboardAvoidingView from '/component/layout/KeyboardAvoidingView';
import ModalHeader from '/component/layout/ModalHeader';
import NavigationHeader from '/component/layout/NavigationHeader';
import LastChangeDateComponent from '/component/partial/LastChangeDateComponent';
import NewInfoPopover from '/component/partial/NewInfoPopover';
import {
  CLIENT_PROFILE as CLIENT_PROFILE_KEY,
  ORDER_DETAILS,
} from '/enum/records.enum';
import {CLIENT_PROFILE, COACH_PROFILE} from '/enum/recordType.enum';
import {EVENT_NAMES, SCREEN_NAMES, USER_TYPES} from '/enum/tealium.enum';
import {createPopoverProvider} from '/provider/PopoverProvider';
import {withTranslation} from '/provider/TranslationProvider';
import {
  generateCallback,
  generateComponentCallback,
} from '/util/component.util';
import {getDateUtilDefaultInstance} from '/util/date.util';
import {shouldReleaseFeature} from '/util/featureRelease.util';
import {getTealiumUtilDefaultInstance} from '/util/tealium';

import {TaskDetails} from './ClientJourney/TaskDetails';
import {Alerts} from './Alerts';
import ClientHealthJourneyTab from './ClientHealthJourneyTab';
import ClientInformation from './ClientInformation';
import {ClientJourney} from './ClientJourney';
import {styles} from './ClientProfile.style';
import Contact from './Contact';
import CreditsAndRewards from './CreditsAndRewards';
import DateJoined from './DateJoined';
import EditNotes from './EditNotes';
import Header from './Header';
import NextPremierOrder from './NextPremierOrder';
import Notes from './Notes';
import OrderDetail from './OrderDetail';
import OrderHistory from './OrderHistory';
import OrderHistoryList from './OrderHistoryList';

export class ClientProfile extends React.PureComponent {
  popoverProvider: any;

  constructor(...args: any[]) {
    // @ts-expect-error TS(2556): A spread argument must either have a tuple type or... Remove this comment to see the full error message
    super(...args);

    this.popoverProvider = createPopoverProvider();
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  componentDidMount() {
    // @ts-expect-error TS(2339): Property 'hasData' does not exist on type 'Readonl... Remove this comment to see the full error message
    const {hasData, fetchData, ts, getAlerts, fetchMwlhr, featureFlag} =
      this.props;
    const {ff_client_coach = ''} = featureFlag;
    if (!hasData) {
      AccessibilityInfo.announceForAccessibility(ts('loading, Loading'));
      if (shouldReleaseFeature(ff_client_coach)) {
        fetchMwlhr();
      }
      fetchData();
      getAlerts();
    }
  }

  renderLoading() {
    // @ts-expect-error TS(2339): Property 'onClose' does not exist on type 'Readonl... Remove this comment to see the full error message
    const {onClose} = this.props;

    return (
      // @ts-expect-error TS(2769): No overload matches this call.
      <ModalHeader
        isProfileScreen
        closeIconName={'chevron-left'}
        onClose={onClose}
        style={{base: styles.base}}>
        <View style={[styles.content, styles.contentLoading]}>
          <LoadingIndicator size="large" />
        </View>
      </ModalHeader>
    );
  }

  getMainScreenComponent() {
    const {Consumer: PopoverConsumer} = this.popoverProvider;
    const {
      // @ts-expect-error TS(2339): Property 'onClose' does not exist on type 'Readonl... Remove this comment to see the full error message
      onClose,
      // @ts-expect-error TS(2339): Property 'recordId' does not exist on type 'Readon... Remove this comment to see the full error message
      recordId,
      // @ts-expect-error TS(2339): Property 'ts' does not exist on type 'Readonly<{}>... Remove this comment to see the full error message
      ts,
      // @ts-expect-error TS(2339): Property 'onShowRecord' does not exist on type 'Re... Remove this comment to see the full error message
      onShowRecord,
      // @ts-expect-error TS(2339): Property 'coachId' does not exist on type 'Readonl... Remove this comment to see the full error message
      coachId,
      // @ts-expect-error TS(2339): Property 'coachName' does not exist on type 'Reado... Remove this comment to see the full error message
      coachName,
      // @ts-expect-error TS(2339): Property 'userId' does not exist on type 'Readonly... Remove this comment to see the full error message
      userId,
      // @ts-expect-error TS(2339): Property 'featureFlag' does not exist on type 'Rea... Remove this comment to see the full error message
      featureFlag: remoteFeatureFlag,
      // @ts-expect-error TS(2339): Property 'activationDate' does not exist on type '... Remove this comment to see the full error message
      activationDate,
      // @ts-expect-error TS(2339): Property 'firstOrderId' does not exist on type 'Re... Remove this comment to see the full error message
      firstOrderId,
      // @ts-expect-error TS(2339): Property 'mwlData' does not exist on type 'Re... Remove this comment to see the full error message
      mwlData,
      // @ts-expect-error TS(2339): Property 'lastPaidRank' does not exist on type 'Re... Remove this comment to see the full error message
      lastPaidRank,
      // @ts-expect-error TS(2339): Property 'coach_highest_rank' does not exist on type 'Re... Remove this comment to see the full error message
      highestAchievedRank,
    } = this.props;

    const sendEvent = getTealiumUtilDefaultInstance().generateTrackEvent({
      eventName: EVENT_NAMES.navigationClick,
    });

    return ({navigation: {navigate, push}}: any) => {
      const screenComponent = useRef(({popoverShow}: any) => {
        const onPageLoadSendEvent =
          getTealiumUtilDefaultInstance().generateTrackEvent({
            eventName: EVENT_NAMES.onPageLoad,
          });

        const handleViewMoreOrderHistoryRef = useRef(() => {
          navigate('client-profile-order-history-list-screen');
          onPageLoadSendEvent({
            currentScreenName: SCREEN_NAMES.orderHistoryList,
            previousScreenName: SCREEN_NAMES.clientProfile,
            lastPaidRank: lastPaidRank,
          });
        });

        const handleOrderPressRef = useRef(({orderId}: any) => {
          push('client-profile-order-detail-screen', {
            orderId,
            modalName: ORDER_DETAILS,
          });
        });

        const handleTaskPressRef = useRef(
          ({taskItem, taskChecked, onTaskStatusChange}: any) => {
            navigate('client-journey-task-details-screen', {
              taskItem,
              taskChecked,
              onTaskStatusChange,
            });
          },
        );
        const profileClickSendEvent =
          getTealiumUtilDefaultInstance().generateTrackEvent({
            eventName: EVENT_NAMES.profileClick,
          });

        const generateOnViewProfilePress = generateCallback({
          func: profileClickSendEvent,
          params: {
            userType: USER_TYPES.client,
            userId: coachId,
            userFullName: coachName,
            lastPaidRank: lastPaidRank,
          },
        });
        const handleShowInfoPopoverRef = useRef((payload: any) =>
          popoverShow(NewInfoPopover, payload),
        );
        const isFrontlineClient = coachId === userId;
        const isRecentClient =
          getDateUtilDefaultInstance().getDaysToToday(activationDate) < 365;

        const showClientJourney =
          // @ts-expect-error TS(2339): Property 'featureFlag' does not exist on type 'Rea... Remove this comment to see the full error message
          this.props.featureFlag.showClientJourney &&
          isFrontlineClient &&
          isRecentClient;

        const {ff_client_coach = ''} = remoteFeatureFlag;

        const {width, height} = useWindowDimensions();
        const isLandscape = width > height;

        const Tab = createMaterialTopTabNavigator();
        return (
          // @ts-expect-error TS(2769): No overload matches this call.
          <ModalHeader
            isProfileScreen
            onClose={onClose}
            closeIconName={'chevron-left'}
            title={ts('clientProfile', 'Client profile')}
            style={{base: styles.base}}>
            <Header clientId={recordId} />
            {!shouldReleaseFeature(ff_client_coach) ? (
              <ScrollView style={styles.content}>
                <DateJoined
                  clientId={recordId}
                  onCoachProfilePress={() => {
                    onShowRecord({
                      recordType: COACH_PROFILE,
                      recordId: coachId,
                    });
                    generateOnViewProfilePress();
                  }}
                />
                <Contact clientId={recordId} />
                {remoteFeatureFlag.showCoachAndClientNotes && (
                  <Notes
                    clientId={recordId}
                    disabled={true}
                    greyOutTextInputValue={false}
                    onPress={() => navigate('client-notes-edit-screen')}
                    FooterComponent={LastChangeDateComponent}
                    showEditNotesLabel={true}
                  />
                )}
                {remoteFeatureFlag.showClientAlerts && (
                  <Alerts clientId={recordId} />
                )}
                {showClientJourney && (
                  <ClientJourney
                    clientId={recordId}
                    onOrderPress={handleOrderPressRef.current}
                    onShowTaskDetail={handleTaskPressRef.current}
                    orderId={firstOrderId}
                    popoverShow={popoverShow}
                  />
                )}
                <NextPremierOrder clientId={recordId} isClientProfile />
                <CreditsAndRewards clientId={recordId} />
                <OrderHistory
                  clientId={recordId}
                  onOrderPress={handleOrderPressRef.current}
                  onViewMore={handleViewMoreOrderHistoryRef.current}
                />
                <View style={styles.sections} />
              </ScrollView>
            ) : (
              <View style={styles.content}>
                <Tab.Navigator
                  style={{tabBarStyle: styles.tabLayout}}
                  screenOptions={{
                    tabBarAllowFontScaling: false,
                    tabBarLabelStyle: {
                      textTransform: 'none',
                    },
                    ...(isLandscape && {tabBarItemStyle: {flex: 1}}),
                  }}>
                  <Tab.Screen
                    name="Client Information"
                    listeners={{
                      tabPress: () => {
                        sendEvent({
                          userType: USER_TYPES.client,
                          menuType: 'profile_tabs',
                          buttonName: 'client_information',
                          buttonType: 'tab',
                          screenName: 'profile',
                          lastPaidRank: lastPaidRank,
                          coach_highest_rank: highestAchievedRank,
                          coach_id: String(coachId),
                        });
                      },
                    }}
                    children={props => (
                      <ClientInformation
                        {...props}
                        recordId={recordId}
                        push={push}
                        coachId={coachId}
                        onShowRecord={onShowRecord}
                        popoverShow={popoverShow}
                        navigate={navigate}
                        activationDate={activationDate}
                        userId={userId}
                        firstOrderId={firstOrderId}
                      />
                    )}
                    options={{tabBarLabel: 'Client Information'}}
                  />
                  {isFrontlineClient && (
                    <Tab.Screen
                      name="Health Journey"
                      children={props => (
                        <ClientHealthJourneyTab
                          {...props}
                          mwlData={mwlData[recordId]}
                          clientId={recordId}
                          onShowInfoPopover={handleShowInfoPopoverRef.current}
                        />
                      )}
                      listeners={{
                        tabPress: () => {
                          sendEvent({
                            userType: USER_TYPES.client,
                            menuType: 'profile_tabs',
                            buttonName: 'health_journey',
                            buttonType: 'tab',
                            screenName: 'profile',
                            lastPaidRank: lastPaidRank,
                            coach_highest_rank: highestAchievedRank,
                            coach_id: String(coachId),
                          });
                        },
                      }}
                      options={{tabBarLabel: 'Health Journey'}}
                    />
                  )}
                </Tab.Navigator>
              </View>
            )}
          </ModalHeader>
        );
      });
      return (
        <PopoverConsumer>
          {({popoverShow}: any) => {
            const ScreenComponent = screenComponent.current;
            return <ScreenComponent popoverShow={popoverShow} />;
          }}
        </PopoverConsumer>
      );
    };
  }

  getOrderHistoryListScreenComponent() {
    // @ts-expect-error TS(2339): Property 'recordId' does not exist on type 'Readon... Remove this comment to see the full error message
    const {recordId, fullName, ts} = this.props;

    return ({navigation: {push, goBack}}: any) => {
      const handleOrderPressRef = useRef(({orderId}: any) => {
        push('client-profile-order-detail-screen', {
          orderId,
          modalName: ORDER_DETAILS,
        });
      });
      const handleBackPressRef = useRef(() => {
        goBack();
      });
      const orderHistoryTitle = fullName
        ? ts('orderHistory.titleWithName', `${fullName}'s Order History`)
        : ts('orderHistory.title', 'Order History');

      return (
        <NavigationHeader style={{base: styles.base}} showBack={false}>
          <OrderHistoryList
            // @ts-expect-error TS(2322): Type '{ flex: number; backgroundColor: string; }' ... Remove this comment to see the full error message
            style={styles.content}
            // @ts-expect-error TS(2322): Type 'any' is not assignable to type 'never'.
            clientId={recordId}
            // @ts-expect-error TS(2322): Type '({ orderId }: any) => void' is not assignabl... Remove this comment to see the full error message
            onOrderPress={handleOrderPressRef.current}
            // @ts-expect-error TS(2322): Type '() => void' is not assignable to type 'never'.
            onBackPress={handleBackPressRef.current}
            // @ts-expect-error TS(2322): Type 'string' is not assignable to type 'never'.
            headerTitle={orderHistoryTitle}
          />
        </NavigationHeader>
      );
    };
  }

  getOrderDetailScreenComponent() {
    // @ts-expect-error TS(2339): Property 'recordId' does not exist on type 'Readon... Remove this comment to see the full error message
    const {recordId, onShowRecord} = this.props;

    return ({
      route: {params: {orderId} = {}} = {},
      navigation: {navigate},
    }: any) => {
      const handleViewProfileRef = useRef(({clientId, coachId}: any) => {
        if ((clientId || coachId) === recordId) {
          // If the customer of the order is the same as the current record, then there is no need
          // to call `onShowRecord` as we can simply navigate to the main screen.
          navigate('client-profile-main-screen', {
            modalName: CLIENT_PROFILE_KEY,
          });
        } else {
          // If the customer of the order is not the same as the current record, then we have to
          // call `onShowRecord` to navigate to the profile screen of that customer.
          if (clientId) {
            onShowRecord({recordType: CLIENT_PROFILE, recordId: clientId});
          } else if (coachId) {
            onShowRecord({recordType: COACH_PROFILE, recordId: coachId});
          }
        }
      });

      const handleViewOrderHistoryRef = useRef(() => {
        navigate('client-profile-order-history-list-screen');
      });

      return (
        <NavigationHeader style={{base: styles.base}}>
          <OrderDetail
            // @ts-expect-error TS(2322): Type '{ flex: number; backgroundColor: string; }' ... Remove this comment to see the full error message
            style={styles.content}
            // @ts-expect-error TS(2322): Type 'any' is not assignable to type 'never'.
            orderId={orderId}
            // @ts-expect-error TS(2322): Type '({ clientId, coachId }: any) => void' is not... Remove this comment to see the full error message
            onViewProfile={handleViewProfileRef.current}
            onViewOrderHistory={handleViewOrderHistoryRef.current}
          />
        </NavigationHeader>
      );
    };
  }

  getTaskDetailsScreenComponent() {
    // @ts-expect-error TS(2339): Property 'recordId' does not exist on type 'Readon... Remove this comment to see the full error message
    const {recordId} = this.props;
    return ({route}: any) => {
      const {
        params: {taskItem, taskChecked, onTaskStatusChange},
      } = route;
      // @ts-expect-error TS(2339): Property 'ts' does not exist on type 'Readonly<{}>... Remove this comment to see the full error message
      const {ts} = this.props;
      return (
        <NavigationHeader
          style={{
            base: styles.base,
            title: styles.taskDetailsTitle,
            iconLeft: styles.taskDetailsIconLeft,
            iconsGap: styles.taskDetailsIconsGap,
          }}
          title={ts('taskDetails', 'Task Details')}>
          <TaskDetails
            taskItem={taskItem}
            taskChecked={taskChecked}
            onTaskStatusChange={onTaskStatusChange}
            clientId={recordId}
          />
        </NavigationHeader>
      );
    };
  }

  EditNotesComponent = () => {
    return () => {
      // @ts-expect-error TS(2339): Property 'recordId' does not exist on type 'Readon... Remove this comment to see the full error message
      const {recordId} = this.props;
      return <EditNotes recordId={recordId} />;
    };
  };

  getProfileStackComponent() {
    const ProfileStackNavigator = createStackNavigator();
    const MainScreen = this.getMainScreenComponent();
    const OrderHistoryListScreen = this.getOrderHistoryListScreenComponent();
    const OrderDetailScreen = this.getOrderDetailScreenComponent();
    const TaskDetailsScreen = this.getTaskDetailsScreenComponent();
    const EditNotesScreen = this.EditNotesComponent();
    // @ts-expect-error TS(2339): Property 'ts' does not exist on type 'Readonly<{}>... Remove this comment to see the full error message
    const {ts} = this.props;

    return generateComponentCallback({
      component: (
        <ProfileStackNavigator.Navigator
          initialRouteName="client-profile-main-screen"
          screenOptions={{headerShown: false}}>
          <ProfileStackNavigator.Screen
            name="client-profile-main-screen"
            component={MainScreen}
            initialParams={{modalName: CLIENT_PROFILE_KEY}}
          />
          <ProfileStackNavigator.Screen
            name="client-profile-order-history-list-screen"
            component={OrderHistoryListScreen}
          />
          <ProfileStackNavigator.Screen
            name="client-profile-order-detail-screen"
            component={OrderDetailScreen}
          />
          <ProfileStackNavigator.Screen
            name="client-journey-task-details-screen"
            component={TaskDetailsScreen}
            options={{title: ts('taskDetails', 'Task details')}}
          />
          <ProfileStackNavigator.Screen
            name="client-notes-edit-screen"
            component={EditNotesScreen}
          />
        </ProfileStackNavigator.Navigator>
      ),
    });
  }

  // @ts-expect-error TS(4114): This member must have an 'override' modifier becau... Remove this comment to see the full error message
  render() {
    const {Provider: PopoverProvider} = this.popoverProvider;
    // @ts-expect-error TS(2339): Property 'hasData' does not exist on type 'Readonl... Remove this comment to see the full error message
    const {hasData} = this.props;
    const ProfileStack = this.getProfileStackComponent();

    return (
      <PopoverProvider>
        {!hasData ? (
          this.renderLoading()
        ) : (
          <KeyboardAvoidingView>
            <ProfileStack />
          </KeyboardAvoidingView>
        )}
      </PopoverProvider>
    );
  }
}

// @ts-expect-error TS(2339): Property 'propTypes' does not exist on type 'typeo... Remove this comment to see the full error message
ClientProfile.propTypes = {
  ts: PropTypes.func,
  recordId: PropTypes.number,
  onClose: PropTypes.func,
  onShowRecord: PropTypes.func,
  hasData: PropTypes.bool,
  fetchData: PropTypes.func,
  fetchMwlhr: PropTypes.func,
  coachId: PropTypes.number,
  fullName: PropTypes.string,
  userId: PropTypes.number,
  coachName: PropTypes.string,
  lastPaidRank: PropTypes.string,
  highestAchievedRank: PropTypes.string,
  firstOrderId: PropTypes.number,
  getAlerts: PropTypes.func,
  featureFlag: PropTypes.shape({
    showClientAlerts: PropTypes.bool,
    showClientJourney: PropTypes.bool,
    ff_client_coach: PropTypes.string,
  }),
  activationDate: PropTypes.string,
  showClientJourney: PropTypes.bool,
  mwlData: PropTypes.object,
};

// @ts-expect-error TS(2339): Property 'defaultProps' does not exist on type 'ty... Remove this comment to see the full error message
ClientProfile.defaultProps = {
  ts: withTranslation.tsDefaultProp,
  recordId: null,
  onClose: noop,
  onShowRecord: noop,
  getAlerts: noop,
  hasData: false,
  fetchData: noop,
  fetchMwlhr: noop,
  coachId: null,
  fullName: '',
  userId: null,
  coachName: '',
  lastPaidRank: '',
  highestAchievedRank: '',
  firstOrderId: null,
  featureFlag: {
    showClientAlerts: false,
    showClientJourney: false,
    showCoachAndClientNotes: false,
    ff_client_coach: null,
  },
  activationDate: '',
  showClientJourney: false,
  mwlData: noop,
};

export default withTranslation('screen.clientProfile')(ClientProfile);
